import styled from '@emotion/styled';

const Section = styled.section`
	padding: 3rem 1.5rem 5rem;
	background: #f5f5f5;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
`;

const Body = styled.div`
	font-size: 1.25rem;
	line-height: 2rem;
`;

export default function WysiwygBlockZeta({ description }: { description: string }) {
	return (
		<Section id="overview">
			<Inner>
				<Body>{description}</Body>
			</Inner>
		</Section>
	);
}
